import PropTypes from 'prop-types'
import cn from '../modules/cn'
import BackgroundBubble from './BackgroundBubble'

function BubblePage({
  children,
  className,
}) {
  return (
    <div>
      <BackgroundBubble />
      <div className={cn('min-h-screen flex flex-col px-4 items-center justify-center space-y-12 py-12', className)}>
        {children}
      </div>
    </div>
  )
}

BubblePage.propTypes = {
  className: cn.propType,
  children: PropTypes.node,
}

BubblePage.defaultProps = {
  className: null,
  children: null,
}

export default BubblePage
